import { get, over } from "lodash";
import styles from "./toolbox.module.css";
import { useEffect, useRef, useState } from "react";

// Pre-made Toolbox props should extend this interface.
export interface BasicToolboxProps {
  collapsible: boolean;
  showTitleBar?: boolean;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
}

interface ToolboxProps extends BasicToolboxProps {
  title?: string;
  toolboxKey?: string; // To help with re-rendering on content change.
  children: React.ReactNode;
}

export const Toolbox = ({
  title,
  toolboxKey,

  showTitleBar = true,

  children,
}: ToolboxProps) => {
  if (!showTitleBar) {
    return <div className={styles.bodyContent}>{children}</div>;
  }
  return (
    <div className={styles.container}>
      <div className={styles.bodyContainer}>
        <div className={styles.bodyContent}>{children}</div>
      </div>
    </div>
  );
};
